  import firebase from "firebase"
  import firestore from "firebase/firestore"
  
  // Initialize Firebase
  var config = {
    apiKey: "AIzaSyCDV7J7cjg9hMFgDd7aECGijdz1MhHxIWc",
    authDomain: "recipe-manager-e13a2.firebaseapp.com",
    databaseURL: "https://recipe-manager-e13a2.firebaseio.com",
    projectId: "recipe-manager-e13a2",
    storageBucket: "recipe-manager-e13a2.appspot.com",
    messagingSenderId: "11471405517"
  };
  const firebaseApp = firebase.initializeApp(config);
  // firebaseApp.firestore().settings({ timestampsInSnapshots: true });

  // Export firestore database
  export default firebaseApp.firestore();


// WEBPACK FOOTER //
// ./src/firebase/init.js